import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService } from '../../services/message.service';
import { ProfileService } from '../../services/profile.service';
import { UserService } from '../../services/user.service';

import { BasicError } from '../../models/error/error';
import { Thread } from '../../models/thread';
import { User } from '../../models/user';
import { Message } from '../../models/messages';
declare var $: any;

@Component({
  selector: 'app-patient-messages-detail',
  templateUrl: './patient-messages-detail.component.html',
  styleUrls: ['./patient-messages-detail.component.css']
})
export class PatientMessagesDetailComponent implements OnInit {
  public threadId = null;
  public thread: Thread = null;
  public messages: Array<Message> = [];
  public threadName: String = null;
  public own: User = null;
  public msg: String = null;
  public buttonClass: String = '';
  public buttonText: String = 'Senden';
  public sendingInProgress = false;
  public modalId = '#modalWindow';
  public modalTitle: String = 'Fehlender Inhalt';
  public modalText: String = 'Bitte geben Sie eine Nachricht ein um diese zu versenden';
  public scrolling = false;
  public participants = [];
  public allusers = [];
  public lastUpdateCountAllUsers = 0;
  public isEmptyUsers = false;
  public timeoutAllUsers = null;

  constructor(private route: ActivatedRoute, private location: Location,
    private messageService: MessageService, private profileService: ProfileService,
    private userService: UserService) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.threadId = params.get('id');
      this.getCurrentUser();
      return this.messageService.getThreadDetail(this.threadId)
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading message');
      } else if (dd instanceof Thread) {
        this.messageService.notifyReadUpdate();
        this.thread = dd;
        this.messages = [];
        for (const msg of this.thread.getMessages()) {
          msg.setMessage(this.replaceForBreak(msg.getMessage()));
          this.messages.push(msg);
        }
        this.participants = this.thread.getUsers();
        this.threadName = this.thread.getSubject();
      } else {
        console.log('Could not read the thread');
      }
    });
  }


  /**
   * Getting current user
   */
  public getCurrentUser() {
    this.profileService.getMyProfile().subscribe(json => {
      if (json instanceof BasicError) {
        console.log('own user failed');
        return;
      }
      this.own = json;
    });
  }


  /**
   * This function sends a message if the message isn't empty
   */
  public sendMessage() {
    if (this.sendingInProgress) {
      return;
    }

    this.sendingInProgress = true;

    this.buttonClass = 'sending';
    this.buttonText = 'Nachricht wird gesendet ...';

    if (this.msg === null || this.msg.length === 0) {
      this.buttonClass = '';
      this.buttonText = 'Senden';
      this.modalTitle = 'Fehlender Inhalt';
      this.modalText = 'Bitte geben Sie eine Nachricht ein um diese zu versenden';
      this.sendingInProgress = false;
      $(this.modalId).modal('show');
      return;
    }

    // Sending is in progress
    this.messageService.sendMessage(this.thread, this.msg).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Sending message failed');
        this.modalText = 'Ihre Nachricht kann zur Zeit nicht versendet werden. Bitte versuchen Sie es später erneut';
        this.modalTitle = 'Senden fehlgeschlagen';
        this.buttonReturnNormal();
        $(this.modalId).modal('show');
        this.buttonClass = 'failed';
        this.buttonText = 'Fehlgeschalgen';
        return;
      }

      // Senden war erfolgreich
      this.buttonClass = 'sended';
      this.buttonText = 'Versendet';
      this.msg = '';
      this.buttonReturnNormal();
      this.refresh();
    });
  }


  /**
   * This function returns the button to it's normal form
   */
  public buttonReturnNormal() {
    const self = this;
    setTimeout(function () {
      self.buttonClass = '';
      self.buttonText = 'Senden';
      self.sendingInProgress = false;
    }, 2000)
  }

  /**
   * Refreshing Thread
   */
  public refresh() {
    this.messageService.getThreadDetail(this.threadId).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading message');
      } else if (dd instanceof Thread) {
        this.thread = dd;
        const messages = this.thread.getMessages();

        for (const msg of messages) {
          let found = false;
          for (const m of this.messages) {
            if (m.getId() === msg.getId()) {
              found = true;
              break;
            }
          }

          if (!found) {
            msg.setMessage(this.replaceForBreak(msg.getMessage()));
            this.messages.push(msg);
          }
        }

        this.participants = this.thread.getUsers();
        this.scrolling = false;
        this.scrollBy();

      } else {
        console.log('Could not read the thread');
      }
    });
  }


  /**
   * this function replaces \n with <br>
   * @param msg message
   */
  public replaceForBreak(msg: String) {
    const re = new RegExp('\n', 'g');
    return msg.replace(re, '<br>');
  }

  /**
   * Scrolling container to deepest point
   */
  public scrollBy() {
    if (this.scrolling) {
      return;
    }

    this.scrolling = true;

    setTimeout(function () {
      document.getElementById('messages-wrapper').scrollBy(0, 100000);
    }, 200);

    setTimeout(function () {
      document.getElementById('messages-wrapper').scrollBy(0, 100000);
    }, 2000);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/patient-messages-detail/patient-messages-detail.component.ts